import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaFileAlt, FaCheckCircle, FaTimesCircle, FaBriefcase, FaCalendar, FaChartLine } from 'react-icons/fa';
import { FaCalendarPlus } from 'react-icons/fa';

const ApplicationReview = ({ application, onUpdateStatus, onScheduleTest, onRemoveApplication }) => {
  const handleReject = () => {
    onUpdateStatus({ ...application, status: 'rejected' });
    // Remove the application after rejection
    onRemoveApplication(application.id);
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-4 hover:shadow-lg transition-all duration-300 border border-gray-100">
      <div className="flex flex-col md:flex-row justify-between items-start gap-4">
        {/* Applicant Info Section */}
        <div className="flex-1 space-y-3 w-full">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-xl flex items-center justify-center shadow-md">
              <FaUser className="text-white text-lg" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900">{application.userName || 'Anonymous'}</h3>
              <div className="flex items-center text-gray-600 text-sm">
                <FaEnvelope className="mr-2 text-indigo-500" />
                {application.userEmail}
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3 bg-gray-50 p-3 rounded-lg text-sm">
            <div className="flex items-center text-gray-700">
              <FaBriefcase className="mr-2 text-indigo-500" />
              <span>{application.position || 'Position Applied'}</span>
            </div>
            <div className="flex items-center text-gray-700">
              <FaCalendar className="mr-2 text-indigo-500" />
              <span>{new Date(application.appliedAt).toLocaleDateString()}</span>
            </div>
          </div>

          {application.atsScore && (
            <div className="bg-gradient-to-r from-indigo-50 to-purple-50 p-3 rounded-lg border border-indigo-100">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center gap-2">
                  <FaChartLine className="text-indigo-600" />
                  <span className="font-semibold text-gray-800">ATS Score:</span>
                  <span className="text-lg font-bold text-indigo-600">{application.atsScore}%</span>
                </div>
                {application.resumeUrl && (
                  <a
                    href={application.resumeUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 px-3 py-1 bg-indigo-100 text-indigo-700 rounded-md hover:bg-indigo-200 transition-colors text-sm"
                  >
                    <FaFileAlt /> Resume
                  </a>
                )}
              </div>
              {application.atsExplanation && (
                <div className="mt-1 text-sm text-gray-600 bg-white p-2 rounded-md border border-gray-100">
                  {application.atsExplanation}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="mt-4 pt-3 border-t border-gray-100">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3">
          <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium ${
            application.status === 'accepted' ? 'bg-green-100 text-green-800' :
            application.status === 'rejected' ? 'bg-red-100 text-red-800' :
            'bg-yellow-100 text-yellow-800'
          }`}>
            <span className="w-2 h-2 rounded-full bg-current"></span>
            {application.status?.charAt(0).toUpperCase() + application.status?.slice(1) || 'Pending'}
            {application.testDate && (
              <span className="ml-2 text-xs">
                Test: {new Date(application.testDate).toLocaleDateString()}
              </span>
            )}
          </span>

          <div className="flex gap-2">
            {application.status === 'accepted' ? (
              <button
                onClick={() => onScheduleTest(application)}
                className="flex items-center justify-center gap-1 px-4 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-300 text-sm"
              >
                <FaCalendarPlus /> Schedule Test
              </button>
            ) : (
              <>
                <button
                  onClick={() => onUpdateStatus({ ...application, status: 'accepted' })}
                  className="flex items-center justify-center gap-1 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 text-sm"
                >
                  <FaCheckCircle /> Accept
                </button>
                <button
                  onClick={handleReject}
                  className="flex items-center justify-center gap-1 px-4 py-2 bg-gradient-to-r from-red-500 to-red-600 text-white rounded-lg hover:from-red-600 hover:to-red-700 transition-all duration-300 text-sm"
                >
                  <FaTimesCircle /> Reject
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationReview;